import { render, staticRenderFns } from "./DataTabs.vue?vue&type=template&id=8b7c39ca&scoped=true"
import script from "./DataTabs.vue?vue&type=script&lang=js"
export * from "./DataTabs.vue?vue&type=script&lang=js"
import style0 from "./DataTabs.vue?vue&type=style&index=0&id=8b7c39ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7c39ca",
  null
  
)

export default component.exports